import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import ReactTooltip from 'react-tooltip'
import Icon from 'components/common/elements/Icon'

import styles from './Tag.scss'

class Tag extends PureComponent {
	constructor(){
		super();
		this.state = {
			showTooltip: false
		}
	}
	showTooltip(){
		const { nameContainer, name } = this;
		this.setState({
			showTooltip: nameContainer.offsetWidth < name.offsetWidth
		})
	}
	componentDidMount(){
		this.showTooltip();
	}
	render(){
		const { label, close, hideCross = false, className = '', style } = this.props;
		const { showTooltip } = this.state;
    let attrs = {};
    if (showTooltip) {
      attrs['data-tip'] = label
    }
		return (
			<span className={cn(styles.tag, {'gs-tooltip': showTooltip, [className]: true})}
            style={style}
            {...attrs}
					  data-eventbreack='true'>
				<span className={styles.tagFace}
              data-eventbreack='true'
              ref={(nameContainer) => { this.nameContainer = nameContainer }}>
			 		<span ref={(name) => { this.name = name }} data-eventbreack='true'>
			 			{label}
			 		</span>
		 		</span>
        {!hideCross && (
          <span onClick={close} data-eventbreack='true'>
            <Icon icon="Cross" size={14}/>
          </span>
        )}
        <ReactTooltip effect="solid" place="bottom"/>
			</span>
		)
	}
};

Tag.propTypes = {
	label: PropTypes.string.isRequired,
  close: PropTypes.func,
  hideCross: PropTypes.bool,
};

export default Tag;
